import { formatCurrency } from "../../../../services/format";
import { connectListView, ListView, ListViewColumnType } from "../../../UI/view/list-view";
import { needsApprovalDataSource } from "./data-source";
import { FormItemType } from "../../../UI/view/component-map";
import { ApproveTransactions } from "../../../../services/requests/billing/dewar-billing-requests";

export const columns = [
  {
    Header: '',
    accessor: 'checked',
    type: ListViewColumnType.checkbox,
    excludeGlobalFilter: true,
  },
  {
    Header: 'Order Number',
    accessor: 'paymentSourceBatchNumber',
    type: ListViewColumnType.link,
    linkPath: ({ val, row }) => row.original.url,
    newLink: true
  },
  {
    Header: 'Customer #',
    accessor: 'customerId',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ row: { original: { amount } } }) => formatCurrency(amount),
  },
  {
    Header: 'Tax',
    accessor: 'tax',
    Cell: ({ row: { original: { tax } } }) => formatCurrency(tax),
  },
  {
    Header: 'Total',
    accessor: 'total',
    Cell: ({ row: { original: { total } } }) => formatCurrency(total),
  },
  {
    Header: 'Invoice Date',
    accessor: 'transactionDate',
    defaultSort: true,
    defaultSortDirection: 'desc',
    type: ListViewColumnType.date
  },
];
export const needsApproval = {
  toolbar: [
    {
      type: FormItemType.button,
      label: 'Approve Selected',
      permissions: {
        read: [1, 14, 15, 18],
        write: [1, 15],
        admin: [1, 15],
      },
      handler: async ({ getValues, confirm, loadData }) => {
        const vals = getValues();
        const transactions = vals.needsApprovalSelection;
        if (!transactions?.length) {
          await confirm('No transactions are selected. Please select transactions from the list below then press approve.', true)
        } else {
          if (await confirm("Are you sure you want to approve the selected transactions?") == true) {
            let isError = false;
            try {
              await ApproveTransactions({ transactions: transactions.map(b => ({transactionId: b.transactionId, amount: b.amount, tax: b.tax })) });
            } catch (e) {
              isError = true;
              await confirm('There was an error approving transactions:' + e, true)
            }
            if (!isError) {
              await confirm('Transactions have been approved successfully.', true);
              loadData();
            }
          }
        }
      }
    }
  ],
  columns: columns
} as ListView;

export const [NeedsApproval, _] = connectListView(needsApproval, needsApprovalDataSource);